import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	moreButtonOld: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchCurrentPage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementSearchIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchMoreFiltersPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	accessibleDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreButtonOld: {
		id: 'jql-builder-basic.common.more-button-old',
		defaultMessage: 'More',
		description:
			'Dropdown button text which displays additional refinements that can be added to the refinement bar when clicked',
	},
	moreButton: {
		id: 'jql-builder-basic.common.more-button',
		defaultMessage: 'More filters',
		description:
			'Dropdown button text which displays additional refinements that can be added to the refinement bar when clicked',
	},
	addButton: {
		id: 'jql-builder-basic.common.add-button',
		defaultMessage: 'Add filters',
		description:
			'Dropdown button text which displays additional refinements that can be added to the refinement bar when clicked',
	},
	refinementSearch: {
		id: 'jql-builder-basic.jql-editor.refinement-search',
		defaultMessage: 'Search issues',
		description: 'The label of the filtering field for arbitary values.',
	},
	searchCurrentPage: {
		id: 'jql-builder-basic.common.search-current-page',
		defaultMessage: 'Search on current page',
		description: 'Command in the command palette to trigger the page search',
	},
	refinementSearchIssueTermRefresh: {
		id: 'jql-builder-basic.common.refinement-search-issue-term-refresh',
		defaultMessage: 'Search work',
		description: 'The label of the filtering field for arbitary values.',
	},
	moreButtonLabel: {
		id: 'jql-builder-basic.common.more-button-label',
		defaultMessage: 'More filter options',
		description:
			'Dropdown button text which displays additional refinements that can be added to the refinement bar when clicked',
	},
	addButtonLabel: {
		id: 'jql-builder-basic.common.add-button-label',
		defaultMessage: 'Add filter options',
		description:
			'Dropdown button text which displays additional refinements that can be added to the refinement bar when clicked',
	},
	searchMoreFiltersPlaceholder: {
		id: 'jql-builder-basic-picker.common.search-more-filters-placeholder',
		defaultMessage: 'Search more filters',
		description:
			'Placeholder text in search input indicating that the user can search for more filters',
	},
	accessibleDescription: {
		id: 'jql-builder-basic.common.accessible-description',
		defaultMessage: 'Typing letters in the search input updates the search results below.',
		description:
			'Label for the search text field notifying users that typing letters would filter the results',
	},
});
export default messages;
